export const get_ = i18next => (phrase) => {
	return i18next.t(phrase);
};
